'use strict'
import numeral from 'numeral'
import 'numeral/locales/fr-ch'

numeral.locale('fr-ch')

export default numeral
